import { VueMaskDirective } from 'v-mask'

const mask = {
  beforeMount: VueMaskDirective.bind,
  updated: VueMaskDirective.componentUpdated,
  unmounted: VueMaskDirective.unbind
}

export default {
  install: (app) => {
    app.directive('clickOutside', {
      beforeMount (el, binding) {
        el.__clickOutside = e => {
          if (!(el === e.target || el.contains(e.target))) {
            binding.value()
            e.stopPropagation()
          }
        }
        el.__esc = e => {
          if (e.key === 'Escape') binding.value()
        }
        document.body.addEventListener('click', el.__clickOutside)
        document.body.addEventListener('keyup', el.__esc)
      },
      unmounted (el) {
        document.body.removeEventListener('click', el.__clickOutside)
        document.body.removeEventListener('keyup', el.__esc)
        el.__clickOutside = null
        el.__esc = null
      }
    })

    app.directive('closeOnPressEsc', {
      beforeMount (el, binding) {
        el.__esc = e => {
          if (e.key === 'Escape') binding.value()
        }
        document.body.addEventListener('keyup', el.__esc)
      },
      unmounted (el) {
        document.body.removeEventListener('keyup', el.__esc)
        el.__esc = null
      }
    })

    app.directive('mask', mask)
  }
}
